import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const DigitalMediaSharedDocuments = () => {
    return <SharedDocumentsComponent permissionId="22" path="Mídias Digitais" />
}